import PageTransitions from './PageTransitions';
globalThis.pageTransitions = new PageTransitions();
